<template>
  <div>
    <v-simple-table 
      class="table-layout border-table"
      v-if="statusList && statusList.type && statusList.type.length"
    >
      <template v-slot:default>
        <tbody>
          <tr>
            <td>Giai đoạn</td>
            <template v-for="(type, index) in statusList.type">
              <td :key="'type-' + index" :colspan="type.colspan">
                {{ type.type.slice(-2) }}
              </td>
            </template>
          </tr>
          <tr>
            <td>Tên MQH</td>
            <template v-for="name in statusList.name">
              <td 
                :key="'name-' + name.id"
                :style="{ color: 'white', background: name.color }"
              >
                {{ name.name }}
              </td>
            </template>
          </tr>
          <tr>
            <td>Mã</td>
            <template v-for="code in statusList.code">
              <td :key="'code-' + code.id" class="text-uppercase">
                {{ code.code }}
              </td>
            </template>
          </tr>
          <tr>
            <td>Màu</td>
            <template v-for="color in statusList.color">
              <td :key="'color-' + color.id">
                <button
                  :style="{ 
                    borderRadius: '10px', 
                    background: color.color,
                    padding: '15px 10px',
                    width: '60%'
                  }"
                >
                </button>
              </td>
            </template>
          </tr>
          <tr>
            <td>Thứ tự</td>
            <template v-for="(order, orderIndex) in statusList.order">
              <td :key="'order-' + order.id">
                <v-tooltip 
                  bottom
                >
                    <template v-slot:activator="{ on }">
                      <button
                        :class="order.first ? 'change-order-btn disabled' : 'change-order-btn'"
                        :disabled="order.first"
                        @click="order.first ? '' : updateOrder(order.id, statusList.order[orderIndex - 1].order)"
                        v-on="on"
                      >
                        <v-icon>mdi-arrow-left</v-icon>
                      </button>
                    </template>
                    <span>Trước</span>
                </v-tooltip>
                <v-tooltip 
                  bottom
                >
                    <template v-slot:activator="{ on }">
                      <button
                        :class="order.last ? 'change-order-btn disabled' : 'change-order-btn'"
                        :disabled="order.last"
                        v-on="on"
                        @click="order.last ? '' : updateOrder(order.id, statusList.order[orderIndex + 1].order)"
                      >
                        <v-icon>mdi-arrow-right</v-icon>
                      </button>
                    </template>
                    <span>Sau</span>
                </v-tooltip>
              </td>
            </template>
          </tr>
          <tr>
            <td>Thao tác</td>
            <template v-for="action in statusList.action">
              <td :key="'action-' + action.id">
                <div class="action">
                  <v-tooltip 
                    bottom 
                    v-if="action.type !== 'T4' && action.type !== 'T5' && checkAuthorization('contact-status_update')"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn 
                        class="mr-2" 
                        icon 
                        small 
                        color="primary"  
                        v-on="on"
                        @click="editContactStatus(action)"
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>Cập nhật mối quan hệ</span>
                  </v-tooltip>
                  <v-tooltip 
                    bottom 
                    v-if="(action.type !== 'T4' || action.type !== 'T5') && (action.isRequired !== true) && checkAuthorization('contact-status_delete')"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn 
                        icon 
                        small 
                        color="default"  
                        v-on="on"
                        @click="deleteContactStatus(action.id)"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Xóa mối quan hệ</span>
                  </v-tooltip>
                </div>
              </td>
            </template>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-row v-else>
      <v-col cols="12">
        <common-no-result />
      </v-col>
    </v-row>
  </div>
</template>
<script>
  import { contactSourceStatusOptions, contactStatusDefaultColor  } from '../../../helpers/constants'
  export default {
    props: {
      statusList: {
        type: Object,
        default: () => {},
      },
      filterForm: {
        default: () => ({}),
      },
      selectedStore: {
        default: () => ({}),
      }
    },
    data () {
      return {
        contactSourceStatusOptions,
        color: contactStatusDefaultColor,
        contactStatusDefaultColor,
      }
    },
    created () {
    },
    computed: {
      showAction() {
        return this.checkAuthorization('contact-status_update') || this.checkAuthorization('contact-status_delete');
      },
    },
    methods: {
      editContactStatus(status) {
        Bus.$emit('show-contact-status-form-modal', status)
      },

      deleteContactStatus(id) {
        Bus.$emit('delete-contact-status', id)
      },

      updateOrder(id, order) {
        Bus.$emit('update-contact-status-order', id, order)
      }
    },
  }
</script>

<style scoped>
/deep/ .v-data-table {
  border: 1px solid #D7D3F2 !important;
  border-radius: 10px;
}

/deep/ .v-data-table tbody:hover td, .v-data-table tbody:hover th {
  background: white;
}

/deep/ .v-data-table tbody th {
  border-bottom: thin solid #D7D3F2;
}

/deep/ .v-data-table tbody td {
  min-width: 120px;
  color: #4C458D;
  font-size: 16px;
  font-weight: 500;
  border-bottom: thin solid #D7D3F2 !important;
  border-right: thin solid #D7D3F2 !important;
}

/deep/ .v-data-table tbody tr td:last-child {
  border-right: none;
}

/deep/ .v-data-table tbody tr {
  height: 60px !important;
}

.change-order-btn {
  background: black;
  border-radius: 50%;
  margin: 0px 10px;
  font-size: 14px;
}

.change-order-btn i {
  color: white
}

.change-order-btn.disabled {
  background: #A1A1A1;
}
</style>